module.exports = __webpack_public_path__ + "img/go.f7951a62.png";